export default "__VITE_ASSET__CVTJiQ0S__"